import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=8ba8039e"
import script from "./checkout.vue?vue&type=script&lang=js"
export * from "./checkout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PrimaryButton: require('/vercel/path0/components/ui/primaryButton.vue').default,OnOff: require('/vercel/path0/components/ui/onOff.vue').default,Checkbox: require('/vercel/path0/components/ui/checkbox.vue').default,Img: require('/vercel/path0/components/ui/img.vue').default})
